import { StructureInfo } from '../models/structure-info';
import { StructuredInfoListDto } from '../dto/structured-info-list-dto';
import { StructureList } from '../models/structure-list';
import { StructuredInfoDto } from '../dto/structured-info-dto';
import { LDWDocument } from '../models/LDWDocument';
import { DocumentDto } from '../dto/document-dto';
import { DocumentDetail } from '../models/document-detail';
import { RBConvert } from '@ldw/roesberg';
import { WebDokuNodeValue } from '../models/web-doku-node-value';
import { TranslateService } from '@ngx-translate/core';

export class StructureInfoFactory {
  static fromStructureDTOList(dtoList: StructuredInfoListDto, webDokuId: string): StructureList {
    const list = new StructureList();
    if (dtoList != null) {
      list.pathInfo = dtoList.path;
      list.searchText = dtoList.searchText;
      dtoList.items.forEach((dto) => {
        const item = this.fromStructureDTO(dto);
        list.data.push(item);
      });
    }
    list.webDokuId = webDokuId;
    return list;
  }

  static fromStructureDTO(dto: StructuredInfoDto): StructureInfo {
    const item = new StructureInfo();
    this.fromBaseDTO(dto, item);
    item.structure = dto.itemType;
    item.resourceImage = dto.resourceImage;
    return item;
  }

  static fromDocumentDTO(translate: TranslateService, dto: DocumentDto): DocumentDetail {
    const item = new DocumentDetail();
    this.fromBaseDTO(dto, item);
    item.created = RBConvert.jsonUTCStringToString(dto.created);
    item.createdBy = dto.createdBy;
    item.job = dto.job;
    item.additionalInfos = dto.additionalInfos;

    item.additionalInfos.push(this.newInfoItem(translate, 'CREATIONDATE', item.created));
    item.additionalInfos.push(this.newInfoItem(translate, 'CREATEDBY', item.createdBy));
    item.additionalInfos.push(this.newInfoItem(translate, 'JOB', item.job));
    return item;
  }

  private static fromBaseDTO(dto: DocumentDto, item: LDWDocument) {
    item.id = dto.id;
    item.text = dto.text;
    item.images = dto.additionalImages;
    item.treePath = dto.treePath;
    item.status.id = dto.statusID;
    item.status.text = dto.statusText;
    item.status.textColor = dto.statusTextColor;
    item.status.backColor = dto.statusBackColor;
    item.hasHistory = dto.hasHistory;
  }

  private static newInfoItem(translate: TranslateService, caption: string, value: string): WebDokuNodeValue {
    const item = new WebDokuNodeValue();
    item.area = translate.instant('DOCUMENT.CREATIONINFO');
    item.caption = translate.instant('DOCUMENT.' + caption);
    item.value = value;
    return item;
  }
}
